<template>
  <nav class="simple-nav">
    <div class="simple-nav__main-navigation" @click="$store.dispatch('nav/setAdditionalNav', '')">
      <NavLogo :homepageUrl="homepageUrl" variant="mobile"></NavLogo>
      <AdditionalMainLinks
        :links="additionalMainLinksReduced"
        class="simple-nav__additional-main-links"
      ></AdditionalMainLinks>
    </div>
    <div class="simple-nav__additional-nav additional-nav">
      <AccountNav />
    </div>
  </nav>
</template>

<script>
import { mapGetters } from 'vuex'
import NavLogo from '@/components/Navigation/NavLogo/NavLogo.vue'
import AdditionalMainLinks from '@/components/Navigation/AdditionalMainLinks/AdditionalMainLinks.vue'
import AccountNav from '@/components/Navigation/AccountNav/AccountNav.vue'

const ADDITIONAL_MAIN_LINK_IDS = ['user', 'mini-cart']

export default {
  name: 'CheckoutNav',
  components: {
    NavLogo,
    AdditionalMainLinks,
    AccountNav,
  },

  data() {
    return {}
  },

  computed: {
    ...mapGetters({
      homepageUrl: 'page/homepageUrl',
      additionalMainLinks: 'nav/additionalMainLinks',
    }),

    additionalMainLinksReduced() {
      return this.additionalMainLinks.filter(({ id }) => ADDITIONAL_MAIN_LINK_IDS.includes(id))
    },
  },

  mounted() {
    const navdata = JSON.parse(document.querySelector('#navData').innerHTML)

    // Update state with asynchronous data
    Object.keys(navdata.desktop).forEach(element => {
      this.$store.dispatch('nav/updateState', {
        key: element,
        value: navdata.desktop[element],
      })
    })

    this.$store.commit('nav/unblockDropdownNav')
  },
}
</script>

<style scoped lang="scss">
.simple-nav {
  z-index: 3;
  position: relative;
  height: $header-height;

  &__main-navigation {
    display: block;
    height: $header-height;
    position: relative;
    z-index: $navigation-z-index - 1;
    border-bottom: 1px solid $color-navigation-border;
    background-color: $color-white;
  }

  &__additional-main-links /deep/ .additional-main-links__link {
    padding-top: 19px;
  }

  &__additional-main-links /deep/ .additional-main-links__cart-items {
    top: 14px;
  }

  &__additional-nav /deep/ .additional-nav__block {
    position: fixed;
    top: $header-height;
    right: $navigation-last-additional-nav-padding-right;
    box-shadow: 0 0 100px 0 transparentize($color-black, 0.97);
    background: $color-white;

    @media ($mq-full) {
      right: $navigation-last-additional-nav-padding-right-full - 10;
    }
  }
}
</style>
